import { useEffect, useState } from "react";

export const useStickyHeader = () => {
    const [isSticky, setSticky] = useState<boolean>(false);

    const checkScrollTop = (): void => {
        setSticky(window.scrollY > 33);
    };

    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop);
        return () => {
            window.removeEventListener('scroll', checkScrollTop);
        };
    }, []);

    return isSticky;

}